import {
  AssetDTOBuilder,
  ListOffersResponseDTOBuilder,
  OfferDTOBuilder,
} from '@wix/ambassador-dealer-offers-serving-service/builders';

export const mockDealerOffering = <CreativeType extends { [key: string]: any }>(
  creative: CreativeType,
) =>
  new ListOffersResponseDTOBuilder()
    .withOffers([
      new OfferDTOBuilder()
        .withAsset(new AssetDTOBuilder().withCreative(creative).build())
        .build(),
    ])
    .build();

export const mockDealerOfferingWithPayloadJson = (payloadJson: string) =>
  new ListOffersResponseDTOBuilder()
    .withOffers([{ asset: { payloadJson } }])
    .build();
